export default {
  minSteps: 1,
  maxSteps: 3,
  stepValues: [
    {
      number: 1,
      label: 'Details',
      url: 'opportunity-details'
    },
    {
      number: 2,
      label: 'Select',
      url: 'opportunity-select'
    },
    {
      number: 3,
      label: 'Edit',
      url: 'opportunity-edit'
    }
  ]
}
